module.exports = __webpack_public_path__ + "img/hr-sand-decal-24.40118ac4.png";